import { type HTMLArkProps, ark } from '@ark-ui/react';

import { cn } from '../../lib/utils';

type CardSize = '1' | '2' | '3' | '4' | '5';

type CardProps = HTMLArkProps<'div'> & {
	variant?: 'surface' | 'ghost' | 'classic';
	size?: CardSize;
};

function Card({ className, variant = 'surface', size = '2', ...props }: CardProps) {
	return (
		<ark.div
			data-slot="card"
			data-variant={variant}
			data-size={size}
			className={cn('pt-card', className)}
			{...props}
		/>
	);
}

export { Card, type CardProps };
